/* Badan Studios — JS global mínimo (cargado con defer). Sin dependencias. */
(function () {
  'use strict';

  // Cabecera fija y transparente: el color del logo y de la píldora se adapta a lo que hay detrás.
  // Tema: "dark" (foto u oscuro) o "light" (claro, incluido el amarillo de marca).
  // Una sección puede forzarlo con data-header-theme="dark|light".
  var header = document.querySelector('[data-header]');
  if (header) {
    var parseRGB = function (value) {
      var m = value.match(/rgba?\(([^)]+)\)/);
      if (!m) return null;
      var p = m[1].split(/[ ,\/]+/).filter(Boolean).map(parseFloat);
      if (p.length > 3 && p[3] === 0) return null; // transparente
      return p;
    };

    var classify = function (rgb) {
      var luminance = 0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2];
      return luminance < 140 ? 'dark' : 'light';
    };

    var themeBehind = function () {
      var y = header.offsetHeight / 2;
      var stack = document.elementsFromPoint(window.innerWidth / 2, y);
      for (var i = 0; i < stack.length; i++) {
        var el = stack[i];
        if (header.contains(el)) continue;
        for (var node = el; node && node !== document.documentElement; node = node.parentElement) {
          if (node.dataset && node.dataset.headerTheme) return node.dataset.headerTheme;
          // Solo una imagen/vídeo grande (tipo fondo de hero) cuenta como fondo oscuro;
          // las pequeñas (cajas, mascotas…) se ignoran y se mira el fondo de su sección.
          if ((node.tagName === 'IMG' || node.tagName === 'VIDEO') && node.offsetWidth > window.innerWidth * 0.5) return 'dark';
          var rgb = parseRGB(getComputedStyle(node).backgroundColor);
          if (rgb) return classify(rgb);
        }
      }
      return 'light';
    };

    var ticking = false;
    var update = function () {
      ticking = false;
      header.dataset.theme = themeBehind();
    };
    var requestUpdate = function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('load', requestUpdate);
    update();
  }

  // Menú móvil: cerrar con Escape.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[open][data-close-on-escape]').forEach(function (details) {
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.focus();
    });
  });

  // Selector de idioma: cerrar el desplegable al pulsar fuera o con Escape.
  var langSwitches = document.querySelectorAll('[data-lang-switch]');
  if (langSwitches.length) {
    document.addEventListener('click', function (event) {
      langSwitches.forEach(function (details) {
        if (details.open && !details.contains(event.target)) details.open = false;
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      langSwitches.forEach(function (details) {
        if (!details.open) return;
        details.open = false;
        details.querySelector('summary').focus();
      });
    });
  }

  // Blog: botón «Copiar enlace» del artículo.
  document.querySelectorAll('[data-copy-link]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(button.dataset.copyLink).then(function () {
        var status = button.parentElement.querySelector('.article-share__status');
        if (status) status.textContent = button.dataset.copiedLabel;
        button.classList.add('is-copied');
        setTimeout(function () {
          button.classList.remove('is-copied');
          if (status) status.textContent = '';
        }, 2000);
      });
    });
  });

  // Idioma: los enlaces internos escritos a mano en los ajustes de las secciones
  // (p. ej. /pages/contact) no llevan el prefijo del idioma (/en, /ca…). Se lo añadimos
  // para no volver al español al navegar. Los enlaces ya generados por Shopify no se tocan.
  var localeRoot = ((window.BadanRoutes && window.BadanRoutes.root_url) || '/').replace(/\/$/, '');
  if (localeRoot) {
    var localizable = /^\/(pages|collections|products|blogs|search|cart|policies)(\/|$|\?|#)/;
    document.querySelectorAll('a[href^="/"]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (href === '/') {
        link.setAttribute('href', localeRoot);
      } else if (localizable.test(href) && href.indexOf(localeRoot + '/') !== 0) {
        link.setAttribute('href', localeRoot + href);
      }
    });
  }

  // Vídeos de «Cómo se juega»: se reproducen sin sonido al verse y se pausan al salir.
  var autoVideos = document.querySelectorAll('.how-video__media');

  // Portadas diferidas: se piden cuando la fila de vídeos está a punto de entrar en pantalla
  // (todas a la vez, para que las del carrusel ya estén al deslizar).
  var lazyPosters = document.querySelectorAll('video[data-poster]');
  var showPoster = function (video) {
    video.setAttribute('poster', video.getAttribute('data-poster'));
    video.removeAttribute('data-poster');
  };
  if ('IntersectionObserver' in window) {
    var posterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.querySelectorAll('video[data-poster]').forEach(showPoster);
        posterObserver.unobserve(entry.target);
      });
    }, { rootMargin: '600px 0px' });
    lazyPosters.forEach(function (video) {
      posterObserver.observe(video.closest('.how-videos') || video.parentElement);
    });
  } else {
    lazyPosters.forEach(showPoster);
  }

  if (autoVideos.length && 'IntersectionObserver' in window) {
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (typeof video.play !== 'function') return;
        if (entry.isIntersecting) {
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.4 });
    autoVideos.forEach(function (video) {
      if (video.tagName === 'VIDEO') videoObserver.observe(video);
    });
  }

  // Botón «Toca para activar el sonido»: activa este vídeo y silencia los demás.
  document.querySelectorAll('[data-video-sound]').forEach(function (button) {
    button.addEventListener('click', function () {
      var video = button.closest('[data-video-card]').querySelector('video');
      if (!video) return;
      var turnOn = video.muted;
      document.querySelectorAll('[data-video-card] video').forEach(function (other) {
        other.muted = true;
      });
      document.querySelectorAll('[data-video-sound]').forEach(function (other) {
        other.setAttribute('aria-pressed', 'false');
      });
      video.muted = !turnOn;
      if (turnOn) {
        video.currentTime = 0;
        video.play();
        button.setAttribute('aria-pressed', 'true');
      }
    });
  });

  // Botones de compra de las secciones del juego: añaden el producto de la página al carrito.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-buy-trigger]');
    if (!trigger) return;
    var form = document.querySelector('[data-product-section] form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    if (form.requestSubmit) {
      form.requestSubmit(form.querySelector('.product-buy__submit'));
    } else {
      form.submit();
    }
  });

  // Preguntas frecuentes: filtro por tema.
  document.querySelectorAll('[data-faq]').forEach(function (faq) {
    var topics = faq.querySelectorAll('[data-faq-topic]');
    topics.forEach(function (button) {
      button.addEventListener('click', function () {
        var topic = button.dataset.faqTopic;
        topics.forEach(function (other) {
          other.classList.toggle('is-active', other === button);
          other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
        });
        faq.querySelectorAll('[data-faq-item]').forEach(function (item) {
          item.hidden = topic !== '' && item.dataset.faqItem !== topic;
        });
      });
    });
  });

  // Publicaciones de Instagram embebidas: el script oficial se carga solo al acercarse a la sección.
  var igSection = document.querySelector('[data-instagram-embeds] .instagram-media');
  if (igSection) {
    var loadInstagram = function () {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
      document.body.appendChild(script);
    };
    if ('IntersectionObserver' in window) {
      var igObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          igObserver.disconnect();
          loadInstagram();
        }
      }, { rootMargin: '600px' });
      igObserver.observe(igSection);
    } else {
      loadInstagram();
    }
  }

  // Carruseles con flechas: se muestran solo si la lista se puede deslizar y se
  // desactivan al llegar a cada extremo.
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;

    function step() {
      var item = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }

    function update() {
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      carousel.classList.toggle('is-scrollable', scrollable);
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  // Cifras: cuentan desde 0 hasta data-count-to cuando aparecen en pantalla.
  var counters = document.querySelectorAll('[data-count-to]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function runCounter(el) {
    var target = parseFloat(el.getAttribute('data-count-to')) || 0;
    var start = null;
    var DURATION = 1600;
    function step(ts) {
      if (!start) start = ts;
      var t = Math.min(1, (ts - start) / DURATION);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(target * eased).toLocaleString('es-ES');
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if (counters.length && 'IntersectionObserver' in window && !reduceMotion) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          runCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) {
      el.textContent = '0';
      counterObserver.observe(el);
    });
  }

  // Animación de entrada al hacer scroll.
  var revealEls = document.querySelectorAll('.reveal, .sticker');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }
})();
